<template>
  <div class="align-middle">
		<img class="logolawn" src="../assets/Logo-Moment-Lawn-blanco.png" alt="logo Carrasco Lawn Tennis">
		<div class='stepTitle'><h2>Registrate a la Clínica<br>con Daniel Orsanic.</h2></div>
    <b-card id="form">
      <b-form-group>
        <div class="align-left">
        <label class="required" for="participante1">Participante</label></div>
      <b-input-group>
        <b-input-group-prepend is-text>
          <b-icon icon="person"></b-icon>
        </b-input-group-prepend>
        <b-form-input
				  class="inputcustom"
          required
          type="text"
          name="participante1"
          id="participante1"
          placeholder="Nombre y apellido"
          v-model="participante1"
          v-bind:class="{ 'is-invalid': errors.includes('participante1') }"
        ></b-form-input>
        <div class="invalid-feedback">Campo obligatorio</div>
      </b-input-group>
			<div class="align-left margtop">
        <label class="required" for="">Elegí el horario</label></div>
      <div class="row">
      <div v-for="item in availableHours" v-bind:key="item.code" class="col-6 col-custom">
        <button
          class="btn btn-custom"
          v-bind:class="[ selectedTime === item ? 'btn-danger' : 'btn-outline-danger']"
          @click="selectTime(item)"
        >{{item.text}}</button>
      </div>
    	</div>
			<b-row class="tituloinput margtop">
            <b-col sm="3">
              <label class="required tituloinput" :for="`categoria`">¿Querés formar parte de la charla de las 20:00 hs?</label>
            </b-col>
            <b-col sm="9">
              <b-form-group>
                <b-form-radio-group
                  v-model="categoria"
                  :options="categoriaoptions"
                  name="categoria"
                  v-bind:class="{ 'is-invalid': errors.includes('categoria') }"
                ></b-form-radio-group>
              </b-form-group>
              <div class="invalid-feedback">Campo obligatorio</div>
            </b-col>
          </b-row>
      <b-input-group class="margtop">
        <b-button
          id="btn-chechform"
          size="lg"
          class="confirm-button"
          @click="CheckForm()"
        >Registrarse</b-button>
      </b-input-group>
      <div id="errores" class="disp-none">Tienes campos incompletos</div>
			</b-form-group>
			<div class="osomred">Powered by <a target="_blank" href="https://www.osomdigital.com/"><img class="logoOsom" src="../assets/Moment-Lawn-logo-osom.png" alt="logo de Osom"></a></div>
    </b-card>
  </div>
</template>

<script>
const axios = require('axios').default;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios
  .defaults
  .headers
  .post['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS, PUT, PATCH, DELETE';

export default {
  props: [
    'idcapitan',
  ],
  data() {
    return {
			theme: '#333333',
      cupos: '',
			categoria: '',
      categoriaoptions: [
        {text: 'Si', value: 'Si'},
        {text: 'No', value: 'No'},
      ],
      participante1: '',
      availableHours: [{
            "text": "09:00Hrs",
            "code": "9",
            "capacity": 1000
          },{
            "text": "11:00Hrs",
            "code": "11",
            "capacity": 1000
          }],
			selectedTime: null,
      hasErrors: false,
      errors: [],
    };
  },
  async created() {
    if (this.$route.query.c) {
     this.$route.query.c
     this.idcapitan = this.$route.query.c; 
    }
    var link = document.createElement( "link" );
    link.href = "css/stylesv23.css";
    link.rel = "stylesheet";
    document.getElementsByTagName( "head" )[0].appendChild( link );
  },
  methods: {
		selectTime(time) {
      this.selectedTime = time;
    },
    async next1() {
      document.getElementById('btn-chechform').disabled = true;
        console.log(this.selectedTime.code);
        console.log(this.availableHours);
        await axios.post('https://lawn-tennis.wapchita.com/historiales/setGroupV3/', {
          "id": `${this.idcapitan}`,
          "code": `${this.selectedTime.code}`,
          "p1": `${this.participante1}`,
					"category": `${this.categoria}`,
        })
        .then((response) => {
          if (response.data.code != 200) {
              console.error('error registro de pedido');
              console.error(response.data);
              window.alert("No se puedo guardar su información, le solicitamos que reintente")
              document.getElementById('btn-chechform').disabled = false;
            } else {
              console.log(response.data);
          this.$router.push({
            name: 'confirm',
            params: {},
          });
          }
        })
        .catch((error) => {
          console.log(error);
          window.alert("Hubo un error, le solicitamos que reintente")
          document.getElementById('btn-chechform').disabled = false;
        });
    },
    async CheckForm() {
      let divErr = document.getElementById("errores")
      this.errors = [];
      if (this.participante1 === '') {
        this.errors.push('participante1');
        divErr.classList.remove("disp-none")
      }
      if (this.participante1.includes(' ') === false) {
        window.alert("Es necesario agregar nombre y apellido de los participantes")
        this.errors.push('participante1');
        divErr.classList.remove("disp-none")
      }  
			if (this.categoria === '') {
        this.errors.push('categoria');
        divErr.classList.remove("disp-none")
      }
			if (this.selectedTime === null) {
				this.errors.push('participante1');
        divErr.classList.remove("disp-none")
			}
      if (this.errors.length === 0) {
        divErr.classList.add("disp-none")
        this.next1();
      } 
    },


  },
};
</script>

<style>
  em{
    font-style: normal !important
  }
  button{
    margin: auto
  }
  .confirm-button{
    border-width: 0;
    border-radius: 5px;
    font-family: 'MontserratMedium';
  }
  .disp-none{
    display: none !important
  }
  #errores{
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  }

  .required::after{
  content:" *";
  color: red;
  }
  label{
  margin-bottom: 0px !important;
  margin-top: 0.55rem !important;
  }
  .tituloinput{
  margin-bottom: 10px !important;
  }

  .input-group{
    margin: 0rem !important
  }

  .margtop{
    margin-top: 1rem !important;
  }

  .align-left{
    text-align: left !important;
  }

	.col-custom{
    margin-bottom: 0px !important
	}
  .btn-custom { 
		width: 100%;
		margin: 0px !important
	}
	/*h2{
		margin-bottom: 1.8rem;
		font-family: 'MontserratBold';
		font-size: 200%;
		color: white;
		text-align: left;
	}
	#app{
		background-color: #fa4f48;
		color: white;
	}*/
	#form{
		background-color: white !important;
		color: black !important;
		border-radius: 15px;
		box-shadow: none;
		border: none;
		margin-bottom: 5px;
		margin-left: 5px;
		margin-right: 5px;
	}
	.btn-danger:hover{
	 box-shadow: none !important;
	}
	.btn-outline-danger{
	 box-shadow: none !important;
	 color: #fa4f48 !important;
	 border-color: #fa4f48 !important;
	}
	.btn-danger{
		color: white !important;
		background-color: #ed7777 !important;
		border-color: #ed7777 !important;
	}
	#btn-chechform{
		color: white !important;
		background-color: #fa4f48 !important;
		font-size: 100%;
		padding-left: 1.5rem;
    padding-right: 1.5rem;
		padding-bottom: 1rem;
    padding-top: 1rem;
	}	
	.osomred{
		color: #fa4f48 !important;
		margin-top: 1.4rem;
		font-size: 70%;
	}
	.logolawn{
		margin-top: 5px;
		height: 120px;
		margin-bottom: 1.3rem;
	}
	.logoOsom{
		width: 50%;
	}
	.required{
		font-size: 100%;
    color: #404041;
	}
	.inputcustom{
		background-color: #f5f5f9;
		border-color: #cfd4d9;
		border-radius: 0px 15px 15px 0px;
	}
	.tituloinput .active{
		background-color: #fa4f48 !important;
	}
</style>
